import { useEffect, useState, useRef } from "react"
import { motion, useAnimation } from "framer-motion"
import { useInView } from "react-intersection-observer"
import Button from "components/Buttons"
// Using direct S3 URL for video instead of import
import stars_image from "assets/icons/star_img.svg"
import horseProfileLogo from "assets/icons/logoBgImg.svg"
import "./style.css"
import { useLocation, useNavigate } from "react-router-dom"
import { useLoggedIn } from "../../../stores/auth/authStore"
import { useScrollStore } from "stores/scroll/useScrollStore";

const YoutubeModal = ({ onClose }) => {
  const modalRef = useRef(null)

  const handleCloseModal = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose()
    }
  }

  return (
    <div
      className="fixed bg-transparent w-full inset-0 flex items-center justify-center z-20"
      onClick={handleCloseModal}
    >
      <div ref={modalRef} className="modal-content">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <iframe
          className="w-[280px] h-[200px] sm:w-[400px] sm:h-[280px] md:w-[600px] md:h-[400px] lg:w-[800px] lg:h-[500px] xl:w-[1080px] xl:h-[700px]"
          src="https://www.youtube.com/embed/TDT-_4wcV7c?si=VWzs35CLfert5p4L"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  )
}

export const HorseProfile = () => {
  const { setThirdSectionRef } = useScrollStore();
  const thirdSectionRef = useRef(null);
  const location = useLocation()
  const navigate = useNavigate()
  const { user, show } = useLoggedIn()

  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    setThirdSectionRef(thirdSectionRef);
  }, [setThirdSectionRef]);

  const closeModal = () => {
    setModalOpen(false)
  }

  const onSignUpHandler = async () => {
    navigate("/signup", {
      state: { backgroundLocation: location },
    })
  }

  const mapControls = useAnimation()
  const clayControls = useAnimation()
  const controls = useAnimation()
  const plusIconControls = useAnimation()

  const { ref: mapRef, inView: mapInView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  const { inView: clayInView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  useEffect(() => {
    if (mapInView) {
      mapControls.start("visible")
    }
  }, [mapInView, mapControls])

  useEffect(() => {
    if (clayInView) {
      clayControls.start("visible")
    }
  }, [clayInView, clayControls])

  const mapVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  }

  const { ref: descriptionRef, inView: descriptionInView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  useEffect(() => {
    if (descriptionInView) {
      controls.start("visible")
    }
  }, [descriptionInView, controls])

  // Use useInView to detect when the plus icon comes into view
  const { inView: plusIconInView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  })

  // Use useAnimation to control the animation of the plus icon

  // Use useEffect to trigger the animation when the plus icon is in view
  useEffect(() => {
    if (plusIconInView) {
      plusIconControls.start("visible")
    }
  }, [plusIconInView, plusIconControls])

  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  }
  const buttonVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.2 } },
  }

  return (
    <>
      <div
        ref={thirdSectionRef}
        className={`prof_main py-12 sm:py-16 md:py-20 lg:py-24 overflow-hidden relative ${show && "-z-30"}`}
      >
        <img src={horseProfileLogo || "/placeholder.svg"} alt="horse_profile_logo" className="horse_profile_logo" />

        <div className="absolute flex flex-col w-[90%] sm:w-[84%] justify-center items-center top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%] h-auto xl:min-h-[480px] 2xl:flex-row-reverse px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-6 sm:py-8 md:py-10 lg:py-12">
          <div className="relative flex flex-col 2xl:flex-row items-center 2xl:items-start ml-0 2xl:ml-[200px] w-full xl:w-auto">
            <motion.video
              className="w-full max-w-[280px] h-[210px] 
                         sm:max-w-[320px] sm:h-[240px] 
                         md:max-w-[400px] md:h-[300px] 
                         lg:max-w-[450px] lg:h-[338px] 
                         xl:w-[500px] xl:h-[375px] 
                         object-cover rounded-lg mx-auto xl:mx-0"
              style={{
                clipPath: "inset(4px 4px 4px 4px round 12px)",
              }}
              ref={mapRef}
              src="https://saddlefit-staging-saddlefitpublicbucket-l92n9356me0a.s3.us-east-1.amazonaws.com/2025-06-03+09-42-46.mp4"
              autoPlay
              loop
              muted
              playsInline
              initial="hidden"
              animate={mapControls}
              variants={mapVariants}
            />

            <motion.div
              className="flex flex-col gap-3 mt-4 xl:mt-0 xl:ml-6 max-w-[320px] w-full xl:max-w-[320px]"
              initial="hidden"
              animate={mapControls}
              variants={{
                hidden: { opacity: 0, x: 0, y: 20 },
                visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.5, delay: 0.3 } },
              }}
            >
              <div className="bg-white/10 backdrop-blur-sm p-3 xl:p-4 rounded-lg shadow-lg border border-white/20">
                <h3
                  className="text-[1.2rem] xl:text-[1.5rem] uppercase font-bold mb-2 text-[#2B364B] tracking-[-0.5px]"
                  style={{ fontFamily: '"Barlow Condensed"' }}
                >
                  3D Heat Mapping
                </h3>
                <p className="text-[#343434] text-[12px] xl:text-[14px]" style={{ fontFamily: '"Montserrat"' }}>
                  The colormap compares the saddle tree to the horse.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-3 xl:p-4 rounded-lg shadow-lg border border-white/20">
                <h3
                  className="text-[1.2rem] xl:text-[1.5rem] uppercase font-bold mb-2 text-[#2B364B] tracking-[-0.5px]"
                  style={{ fontFamily: '"Barlow Condensed"' }}
                >
                  Saddle Tree Analysis
                </h3>
                <p className="text-[#343434] text-[12px] xl:text-[14px]" style={{ fontFamily: '"Montserrat"' }}>
                  Real-time analysis of SaddleFit against your horse&apos;s unique shape.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-3 xl:p-4 rounded-lg shadow-lg border border-white/20">
                <h3
                  className="text-[1.2rem] xl:text-[1.5rem] uppercase font-bold mb-2 text-[#2B364B] tracking-[-0.5px]"
                  style={{ fontFamily: '"Barlow Condensed"' }}
                >
                  Perfect Fit Visualization
                </h3>
                <p className="text-[#343434] text-[12px] xl:text-[14px]" style={{ fontFamily: '"Montserrat"' }}>
                  Color-coded display matches ideal saddle to your horse&apos;s measurements.
                </p>
              </div>
            </motion.div>
          </div>

          <div
            ref={descriptionRef}
            className="prof_description mt-[30px] sm:mt-[35px] 2xl:mt-[-32px] flex flex-col justify-center 2xl:justify-end items-center w-full 2xl:w-auto"
          >
            <motion.img
              src={stars_image}
              alt="stars"
              className="w-[250px] h-[27px] sm:w-[280px] sm:h-[30px] md:w-auto md:h-auto"
              initial="hidden"
              animate={controls}
              variants={variants}
            />
            <motion.h2
              className="!text-center 2xl:!text-end text-[1.3rem] sm:text-[1.5rem] md:text-[1.8rem] lg:text-[2rem] px-4 2xl:px-0"
              initial="hidden"
              animate={controls}
              variants={variants}
            >
              Ready to scan your horse?
            </motion.h2>
            <div className="flex relative flex-col sm:flex-row w-full max-w-[325px] sm:max-w-[500px] justify-center 2xl:justify-end items-center mt-[20px] lg:mt-[24px] gap-[12px] sm:gap-[24px]">
              <motion.div initial="hidden" className="w-full sm:w-[259px]" animate={controls} variants={buttonVariants}>
                <Button
                  size
                  onClick={() => {
                    user ? navigate("/event") : onSignUpHandler()
                  }}
                  className="prof_btn_join w-full"
                  tranparent
                >
                  Schedule Now
                </Button>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && <YoutubeModal videoId="YOUR_VIDEO_ID_HERE" onClose={closeModal} />}
    </>
  )
}

export default HorseProfile
